import React, { useState } from "react";

import { useTranslation } from "utils";

import { appVersions } from "enums";

import { Col, MainPage, Row, Svg } from "components";

interface ShareData {
  title: string;
  summary: string;
  link: string;
  image: string;
}

export const Verifying = () => {
  const { t } = useTranslation("meta");

  const [share] = useState<ShareData>({
    title: t("meta:verifying.title"),
    summary: t("meta:verifying.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-up`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });

  return (
    <MainPage pageName={"splash"} share={share}>
      <section>
        <Row align="bottom" className="full-height margin-0">
          <Col className="center">
            <Svg svgName="logos/klim_logo_brandmark_and_text_white" className="pulsating" />
          </Col>
          <Col className="center">
            <p className="grey-text margin-bottom-500">
              v{appVersions[0].major}.{appVersions[0].minor}
            </p>
          </Col>
        </Row>
      </section>
    </MainPage>
  );
};
